import { JFSRequest, executeRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const IS_FROM_LOCALHOST = false

const uploadRiskTnxsEvidenceApi = async (file: any, mid: string) => {
  const data = new FormData()
  data.append('file', file)
  data.append('entityId ', mid)
  const request: JFSRequest<{}> = {
    apiPath: IS_FROM_LOCALHOST
      ? 'http://localhost:8080/api/v1.0/risk/evidence/upload'
      : getUrl(APIEndPoints.uploadEvidence),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: {
      ...getHeaders(),
      ...(IS_FROM_LOCALHOST && { appIDToken: '66', 'x-channel-id': '66' }),
      'Content-Type': 'multipart/form-data',
    },
    body: data,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error?.data?.message ? error?.data : error
    })
}

export { uploadRiskTnxsEvidenceApi }
